/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionOption
 */
export interface QuestionOption {
    /**
     * 
     * @type {string}
     * @memberof QuestionOption
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionOption
     */
    value: string;
}

/**
 * Check if a given object implements the QuestionOption interface.
 */
export function instanceOfQuestionOption(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function QuestionOptionFromJSON(json: any): QuestionOption {
    return QuestionOptionFromJSONTyped(json, false);
}

export function QuestionOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionOption {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'category': !exists(json, 'category') ? undefined : json['category'],
        'value': json['value'],
    };
}

export function QuestionOptionToJSON(value?: QuestionOption | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category': value.category,
        'value': value.value,
    };
}

